module.exports = __webpack_public_path__ + "static/media/highlighted-logo.f8e17216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/highlighted-logo.png
// module id = 60
// module chunks = 0